"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
var _rater = require("@/api/rater");
var _user = require("@/api/user");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _log = require("@/utils/log");
var _moment = _interopRequireDefault(require("moment"));
var _lodash = _interopRequireDefault(require("lodash"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'job',
  data() {
    return {
      start: (0, _moment.default)().subtract(1, 'months'),
      // Hike Start Date
      end: (0, _moment.default)(),
      loading: false,
      query: {
        page: 1,
        limit: 100
      },
      jobs: [],
      jobList: [],
      raterList: []
    };
  },
  computed: {
    startDate: {
      get() {
        var start = (0, _moment.default)().isoWeekYear(this.yearIso).isoWeeks(this.weekOfYear).startOf('isoWeek');
        return start.format("yyyy-MM-DD");
      }
    },
    endDate: {
      get() {
        var end = (0, _moment.default)().isoWeekYear(this.yearIso).isoWeeks(this.weekOfYear).endOf('isoWeek');
        return end.format("yyyy-MM-DD");
      }
    }
  },
  created() {
    this.getRaterList();
  },
  methods: {
    search() {
      this.getJobList();
    },
    getJobList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var start = (0, _moment.default)(this.start).format('YYYY-MM-DD');
      var end = (0, _moment.default)(this.end).format('YYYY-MM-DD');
      console.log(start);
      this.loading = true;
      (0, _rater.getJobs)(token, start, end).then(response => {
        console.log(response.data.tasks);
        this.loading = false;
        this.jobs = response.data.tasks;
        this.jobList = this.jobs.slice(0, this.query.limit);
      }).catch(error => {
        this.loading = false;
        (0, _log.showDebugLog)('GetJobs-api-error', error);
      });
    },
    getRaterList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const query = {
        page: 1,
        limit: 200,
        role: 'otr-rater',
        sort: 'givenName'
      };
      (0, _user.getUserList)(token, query).then(response => {
        // this.list = response.data.items
        this.raterList = response.data.rows.map(s => {
          return {
            uuid: s.uuid,
            name: `${s.givenName} ${s.familyName}`
          };
        });
      }).catch(error => {
        (0, _log.showDebugLog)('GetUserList-api-error', error);
      });
    },
    getUserName(uuid) {
      var staff = this.raterList ? this.raterList.find(u => u.uuid === uuid) : null;
      return staff ? staff.name : '-';
    },
    getPickupStatus(noOfRater, assignedRater) {},
    handleSizeChange(val) {
      this.query.limit = val;
    },
    handleCurrentChange(val) {
      this.query.page = val;
      var end = val * this.query.limit;
      var start = val * this.query.limit - this.query.limit;
      this.jobList = this.jobs.slice(start, end);
    }
  }
};